import { useState, useEffect } from 'react';

const getTimeLeft = (targetDate) => {
  const diff = targetDate.getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const CountdownTimer = ({ targetDate, label = 'EARLY BIRD ENDS IN', variant = 'banner' }) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(targetDate));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  if (!timeLeft) {
    return null;
  }

  const pad = (n) => String(n).padStart(2, '0');

  if (variant === 'inline') {
    return (
      <div className="inline-flex items-center gap-3 border border-[var(--primary)]/40 bg-[var(--surface-highlight)]/30 px-5 py-3 font-mono text-base">
        <span className="text-[var(--text-muted)] uppercase tracking-wider text-sm">{label}</span>
        <span className="text-[var(--primary)] font-bold">
          {timeLeft.days}d {pad(timeLeft.hours)}h {pad(timeLeft.minutes)}m {pad(timeLeft.seconds)}s
        </span>
      </div>
    );
  }

  const segments = [
    { value: timeLeft.days, unit: 'DAYS' },
    { value: timeLeft.hours, unit: 'HRS' },
    { value: timeLeft.minutes, unit: 'MIN' },
    { value: timeLeft.seconds, unit: 'SEC' },
  ];

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="font-mono text-xs uppercase tracking-widest text-[var(--text-muted)]">{label}</p>
      <div className="flex items-center gap-2 sm:gap-3">
        {segments.map((seg, i) => (
          <div key={seg.unit} className="flex items-center gap-2 sm:gap-3">
            <div className="flex flex-col items-center gap-1 border border-[var(--primary)]/40 bg-[var(--surface-highlight)]/30 px-3 sm:px-4 py-2 shadow-[0_0_15px_var(--glow-primary)]">
              <span className="font-mono text-2xl sm:text-4xl font-black text-[var(--primary)]">
                {pad(seg.value)}
              </span>
              <span className="font-mono text-[10px] uppercase tracking-widest text-[var(--text-muted)]">
                {seg.unit}
              </span>
            </div>
            {i < segments.length - 1 && (
              <span className="font-mono text-xl sm:text-2xl text-[var(--accent-cyan)] animate-pulse">:</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
